<template>
  <div class="contents">
    <div class="container-fluid">
      <!-- Header -->
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb-main user-member justify-content-sm-between">
            <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
              <h4 class="text-capitalize fw-500 breadcrumb-title">Laporan Error 463</h4>
            </div>
            <div class="action-btn">
              <button @click="exportCSV" class="btn btn-outline-success" style="margin:5px" :disabled="!rows.length">
                <i class="fas fa-file-csv"></i> Export CSV
              </button>
              <button @click="load" class="btn btn-secondary text-white" style="margin:5px">
                <i class="fas fa-sync"></i> Refresh
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="alert alert-info mb-3">
        <small>
          <i class="fas fa-info-circle"></i>
          <b>Error 463</b> = pesan ditahan WhatsApp karena nomor tujuan belum pernah chat (anti-spam kontak baru).
          User dengan rasio 463 tinggi + volume besar = kandidat diarahkan ke <b>WhatsApp Business API resmi (KlikPesan)</b>.
          Data diperbarui otomatis tiap ~30 menit.
        </small>
      </div>

      <!-- Filter -->
      <div class="row mb-3">
        <div class="col-12">
          <div class="card p-3">
            <div class="d-flex align-items-center" style="gap:10px; flex-wrap:wrap">
              <span class="font-weight-bold">Periode cepat:</span>
              <button v-for="p in presets" :key="p.days" @click="setPreset(p.days)"
                :class="['btn btn-sm', activePreset === p.days ? 'btn-primary':'btn-outline-primary']">{{ p.label }}</button>
              <span class="font-weight-bold" style="margin-left:14px">| Custom:</span>
              <input type="date" v-model="dateFrom" class="form-control form-control-sm" style="width:150px">
              <span>—</span>
              <input type="date" v-model="dateTo" class="form-control form-control-sm" style="width:150px">
              <input v-model="q" @input="onSearch" type="text" class="form-control form-control-sm" style="width:220px" placeholder="cari nama / email">
              <button @click="load" class="btn btn-sm btn-success"><i class="fas fa-filter"></i> Terapkan</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Summary cards -->
      <div class="row" v-if="summary">
        <div class="col-md-4 col-sm-6 mb-3">
          <div class="card p-3" style="border-left:4px solid #5F63F2">
            <div class="text-muted small">📨 TOTAL PENGIRIMAN</div>
            <div class="h4 mb-0 font-weight-bold text-primary">{{ fmt(summary.sum_total) }}</div>
            <small class="text-muted">{{ summary.date_from }} s/d {{ summary.date_to }}</small>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mb-3">
          <div class="card p-3" style="border-left:4px solid #e53935">
            <div class="text-muted small">🚫 TOTAL ERROR 463</div>
            <div class="h4 mb-0 font-weight-bold" style="color:#e53935">{{ fmt(summary.sum_463) }}</div>
            <small class="text-muted">rasio {{ ratePct(summary.sum_463, summary.sum_total) }}</small>
          </div>
        </div>
        <div class="col-md-4 col-sm-6 mb-3">
          <div class="card p-3" style="border-left:4px solid #e65100">
            <div class="text-muted small">👥 USER KENA 463</div>
            <div class="h4 mb-0 font-weight-bold" style="color:#e65100">{{ rows.length }}</div>
            <small class="text-muted">kandidat untuk KlikPesan</small>
          </div>
        </div>
      </div>

      <!-- Trend -->
      <div class="row" v-if="summary && summary.trend && summary.trend.length">
        <div class="col-12 mb-3">
          <div class="card p-3">
            <h6 class="font-weight-bold mb-3"><i class="fas fa-chart-line text-danger"></i> Tren 463 per Hari</h6>
            <div class="chart463">
              <div v-for="(t,i) in summary.trend" :key="i" class="bar463-item">
                <div class="bar463-wrap">
                  <div class="bar463-fill" :style="{ height: barH(t.e463) + '%' }"
                    :title="t.date + ': ' + t.e463 + ' error 463 dari ' + t.total + ' (' + ratePct(t.e463,t.total) + ')'"></div>
                </div>
                <div class="bar463-val">{{ ratePct(t.e463, t.total) }}</div>
                <div class="bar463-lbl">{{ t.date.slice(5) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Top users table -->
      <div class="row">
        <div class="col-12">
          <div class="card global-shadow border bg-white radius-xl w-100 mb-30">
            <div v-if="isLoading" class="text-center p-4">
              <div class="spinner-border" role="status"></div><p class="mt-2 text-muted">Loading...</p>
            </div>
            <div v-else-if="!rows.length" class="text-center text-muted p-4"><p>Tidak ada user yang kena 463 pada periode ini 🎉</p></div>
            <div v-else class="table-responsive">
              <table class="table table-hover mb-0">
                <thead class="bg-light">
                  <tr>
                    <th>#</th><th>User</th><th>Paket</th>
                    <th class="text-right">Total Kirim</th>
                    <th class="text-right">Terkirim</th>
                    <th class="text-right">Error 463</th>
                    <th class="text-right">Rasio 463</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(r,i) in rows" :key="r.owner">
                    <td>{{ i+1 }}</td>
                    <td>
                      <div class="font-weight-bold">{{ r.name || '-' }}</div>
                      <div><small style="font-family:monospace">{{ r.email || '-' }}</small></div>
                      <small class="text-muted">{{ r.phone || '-' }} (#{{ r.owner }})</small>
                    </td>
                    <td><span class="badge badge-light">{{ r.package_name }}</span></td>
                    <td class="text-right">{{ fmt(r.total) }}</td>
                    <td class="text-right text-success">{{ fmt(r.terkirim) }}</td>
                    <td class="text-right font-weight-bold" style="color:#e53935">{{ fmt(r.e463) }}</td>
                    <td class="text-right font-weight-bold">{{ ratePct(r.e463, r.total) }}</td>
                    <td>
                      <span v-if="isCandidate(r)" class="badge badge-danger">🔴 Kandidat KlikPesan</span>
                      <span v-else-if="rate(r) >= 0.1" class="badge badge-warning text-white">🟠 Pantau</span>
                      <span v-else class="badge badge-secondary">🟢 Wajar</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      isLoading: false,
      summary: null,
      rows: [],
      dateFrom: "",
      dateTo: "",
      q: "",
      activePreset: 7,
      presets: [
        { days: 1, label: "Hari Ini" },
        { days: 7, label: "7 Hari" },
        { days: 14, label: "14 Hari" },
        { days: 30, label: "30 Hari" },
      ],
      searchDebounce: null,
    };
  },
  mounted() {
    this.setPreset(7);
  },
  methods: {
    setPreset(days) {
      this.activePreset = days;
      const to = new Date();
      const from = new Date();
      from.setDate(from.getDate() - (days - 1));
      this.dateTo = this.ymd(to);
      this.dateFrom = this.ymd(from);
      this.load();
    },
    ymd(d) {
      return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
    },
    onSearch() {
      clearTimeout(this.searchDebounce);
      this.searchDebounce = setTimeout(() => this.load(), 500);
    },
    async load() {
      this.isLoading = true;
      try {
        const params = { date_from: this.dateFrom, date_to: this.dateTo };
        if (this.q) params.q = this.q;
        const r = await axios.get("admin/463-report", { params });
        const d = r.data.data || {};
        this.summary = d;
        this.rows = d.top_users || [];
      } catch (err) {
        this.$toast.error("Gagal load: " + (err.response?.data?.message || err.message));
      } finally {
        this.isLoading = false;
      }
    },
    fmt(n) { return (parseInt(n) || 0).toLocaleString("id-ID"); },
    rate(r) { const t = parseInt(r.total) || 0; return t ? (parseInt(r.e463) || 0) / t : 0; },
    ratePct(e, t) { t = parseInt(t) || 0; e = parseInt(e) || 0; return t ? (e / t * 100).toFixed(1) + "%" : "0%"; },
    isCandidate(r) { return this.rate(r) >= 0.2 && (parseInt(r.e463) || 0) >= 50; },
    barH(e463) {
      if (!this.summary || !this.summary.trend) return 2;
      const max = Math.max(...this.summary.trend.map(t => parseInt(t.e463) || 0), 1);
      return Math.max(3, ((parseInt(e463) || 0) / max) * 100);
    },
    exportCSV() {
      const head = ["No", "User ID", "Nama", "Email", "Phone", "Paket", "Total Kirim", "Terkirim", "Error 463", "Rasio 463", "Status"];
      const lines = [head.join(",")];
      this.rows.forEach((r, i) => {
        const status = this.isCandidate(r) ? "Kandidat KlikPesan" : (this.rate(r) >= 0.1 ? "Pantau" : "Wajar");
        lines.push([i + 1, r.owner, `"${(r.name || "").replace(/"/g, "'")}"`, r.email || "", r.phone || "",
          `"${(r.package_name || "").replace(/"/g, "'")}"`, r.total, r.terkirim, r.e463, this.ratePct(r.e463, r.total), status].join(","));
      });
      const blob = new Blob(["﻿" + lines.join("\n")], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `laporan-463-${this.dateFrom}_${this.dateTo}.csv`; a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.chart463 { display:flex; align-items:flex-end; gap:4px; min-height:160px; padding:0 4px; }
.bar463-item { flex:1; display:flex; flex-direction:column; align-items:center; text-align:center; }
.bar463-wrap { width:100%; height:120px; display:flex; align-items:flex-end; background:linear-gradient(to bottom,transparent 0%,transparent 80%,#fdecea 100%); border-radius:4px; }
.bar463-fill { width:100%; background:linear-gradient(180deg,#e53935 0%,#ff7043 100%); border-radius:4px 4px 0 0; transition:height .3s; }
.bar463-val { font-size:10px; color:#e53935; font-weight:700; margin-top:3px; }
.bar463-lbl { font-size:10px; color:#6c757d; }
</style>
